import styles from './Views.module.css'

export const CloseWindow = () => {
  return <div className={styles.closeWindow}>You can close this window.</div>
}
